const STRING_CONSTRAINTS = {
  'IS': 'IS',
  'STARTS_WITH': 'STARTS_WITH',
  'ENDS_WITH': 'ENDS_WITH',
  'CONTAINS': 'CONTAINS'
};

export default STRING_CONSTRAINTS;
